import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import Language from '@material-ui/icons/Language';

import { handleClickAway } from 'services/handleClickAway';
import AddRegionFormContainer from 'components/AddRegionForm/AddRegionFormContainer';
import PopoutItem from 'components/PopoutItem/PopoutItem';
import styles from '../InstanceButtonItem.styles';

const propTypes = {
  open: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    actionButton: PropTypes.string.isRequired,
    popoutIconContainer: PropTypes.string.isRequired,
    popoutIconLabel: PropTypes.string.isRequired,
  }).isRequired,
  setUiState: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  anchorEl: PropTypes.shape({}).isRequired,
  statusDisplay: PropTypes.string.isRequired,
  instanceId: PropTypes.string.isRequired,
  metadata: PropTypes.shape({ multiInstanceId: PropTypes.string }).isRequired,
  provider: PropTypes.string.isRequired,
  region: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired,
  service: PropTypes.string.isRequired,
  regionsUnavailable: PropTypes.bool.isRequired,
};

export function UnstyledRegionInstanceButtonItem({
  open,
  classes,
  setUiState,
  disabled,
  anchorEl,
  statusDisplay,
  instanceId,
  metadata,
  provider,
  region,
  name,
  version,
  service,
  regionsUnavailable,
}) {
  function handleClick(e) {
    e.stopPropagation();

    setUiState({
      open: !open,
      anchorEl: e.currentTarget,
    });
  }

  const theButton = (
    <div className={classes.instanceButtonItemContainer}>
      <Button
        disabled={disabled}
        onClick={handleClick}
        classes={{ root: classes.zeroPadding, text: classes.zeroPadding }}
        className={classes.actionButton}
        id="userformpopout-button"
      >
        <div className={classes.popoutIconContainer}>
          <Language disabled={disabled} className={classes.popoutIcon} />
          <span className={classes.popoutIconLabel}>Regions</span>
        </div>
      </Button>
      <PopoutItem
        anchorEl={anchorEl}
        handleClick={handleClick}
        handleClickAway={(e) => handleClickAway(e, anchorEl, () => setUiState({ open: false }))}
        placement="bottom-end"
        open={open}
        popperId="regionformpopout"
      >
        <AddRegionFormContainer
          instanceId={instanceId}
          metadata={metadata}
          provider={provider}
          region={region}
          name={name}
          version={version}
          service={service}
          closePopout={() => setUiState({ open: false })}
          formType="popout"
        />
      </PopoutItem>
    </div>
  );

  const title = regionsUnavailable
    ? 'All available regions have been used.'
    : 'You do not have the required access for this resource. Contact your organization owner.';

  return disabled && statusDisplay === 'Ready' ? (
    <Tooltip title={title} classes={{ tooltip: classes.tooltip }}>
      <span>{theButton}</span>
    </Tooltip>
  ) : (
    theButton
  );
}

UnstyledRegionInstanceButtonItem.propTypes = propTypes;

export const uiConfig = {
  name: 'databaseformpopoutitem',
  state: () => ({
    open: false,
    anchorEl: {},
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledRegionInstanceButtonItem));
